import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { PA_EXPOSURE_DETAIL } from "../keys";

const usePAExposureDetail = (sponsorObjectId, videoId, page = 1) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const enabled = !!(sponsorObjectId && videoId);

  return useQuery({
    queryKey: [PA_EXPOSURE_DETAIL, tenant.id, sponsorObjectId, videoId, page],
    queryFn: () => ApiService.getPlacementAnalysisExposureDetail({
      sponsor_object_id: sponsorObjectId,
      video_id: videoId,
      page,
    }),
    select: (data) => data.data,
    enabled,
    placeholderData: { data: { data: [], summary: {}, total: 0, per_page: 24, current_page: 1 } },
  });
};

export default usePAExposureDetail;
